import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
  input,
  signal,
} from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { Observable } from 'rxjs';

@Directive({
  selector: '[libAsyncButton]',
})
export class AsyncButton<T> {
  primengBtnDirective = inject(ButtonDirective, { self: true });

  elementRef = inject(ElementRef<HTMLButtonElement>);

  @Input()
  libAsyncButton!: () => Observable<T>;

  form = input<any>();

  isWork = signal(false);

  private isButtonDisabled(): boolean {
    const el = this.elementRef.nativeElement;
    return !!(el?.disabled || el?.hasAttribute('disabled'));
  }

  @HostListener('click')
  onClick() {
    if (!this.libAsyncButton) return;
    if (this.isButtonDisabled()) return;
    if (this.isWork()) return;

    const obs$ = this.libAsyncButton();
    if (!obs$) return;

    this.elementRef.nativeElement.disabled = true;
    this.primengBtnDirective.loading = true;
    this.isWork.set(true);

    obs$.subscribe({
      complete: () => {
        this.primengBtnDirective.loading = false;
        this.elementRef.nativeElement.disabled = false;
        this.isWork.set(false);
      },
      error: () => {
        this.primengBtnDirective.loading = false;
        this.elementRef.nativeElement.disabled = false;
        this.isWork.set(false);
      },
    });
  }

  @HostListener('document:keydown.enter')
  enter() {
    if (
      this.form() &&
      this.form().valid &&
      !this.isWork() &&
      !this.isButtonDisabled()
    ) {
      this.onClick();
    }
  }
}
